// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-main-wallet[data-v-ea260c3e] {\n    color: #fbc913;\n}\n.btn-content[data-v-ea260c3e] {\n    font-size: 10px;\n    line-height: 1.2;\n}\n.font-10[data-v-ea260c3e] {\n    font-size: 10px;\n}\n.wallet-list[data-v-ea260c3e] {\n    background-color: #47270a !important;\n    border: 1px solid #6b3b0e !important;\n    border-top: none !important;\n}\n.exchange-rate-menu[data-v-ea260c3e] {\n    width: 99% !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
